import { List } from "immutable";

export const REORDER = "REORDER";
export const REMOVE = "REMOVE";
export const ADD = "ADD";
export const MARK_PUBLISHED = "MARK_PUBLISHED";

export const reorderListItem = (sourceIndex, destinationIndex) => ({ type: REORDER, sourceIndex, destinationIndex });
export const removeListItem = (_id) => ({ type: REMOVE, _id });
export const addListItem = (learningUnit) => ({
  type: ADD,
  learningUnit,
});
// Optimistically flip the given learning units to published, used after a tutorial-level publish so the
// PUBLISHED pills update immediately (apollo-client 2.x does not refetch no-cache queries via refetchQueries).
export const markLearningUnitsPublished = (luIds) => ({ type: MARK_PUBLISHED, luIds });

// helper
const reorder = (list, startIndex, endIndex) => {
  const itemAtStartIndex = list.get(startIndex);
  return list.delete(startIndex).insert(endIndex, itemAtStartIndex);
};

// Reducer
export const reducer = (state, action) => {
  switch (action.type) {
    case REORDER:
      return {
        ...state,
        learningUnits: reorder(state.learningUnits, action.sourceIndex, action.destinationIndex),
      };
    case REMOVE:
      return { ...state, learningUnits: state.learningUnits.filter((lu) => lu._id !== action._id) };
    case ADD:
      return { ...state, learningUnits: List([...state.learningUnits, action.learningUnit]) };
    case MARK_PUBLISHED: {
      const publishedIds = new Set(action.luIds);
      return {
        ...state,
        learningUnits: state.learningUnits.map((lu) =>
          publishedIds.has(lu._id) ? { ...lu, isPublished: true, isSubmittedForReview: false } : lu,
        ),
      };
    }
    default:
      return state;
  }
};
